.biel-search-result-container {
  border: 1px solid var(--biel-search-result-border-color);
  border-radius: var(--biel-search-result-border-radius);
  background-color: var(--biel-search-result-bg-color);
  transition: background-color 0.3s ease;
  margin-top: 6px;
  padding: var(--biel-search-result-padding);
  display: flex;
  flex-direction: column;
}

.biel-search-result-container.selected {
  background-color: var(--biel-search-result-bg-hover-color);
}

.biel-search-result__title {
  font-size: 18px;
  margin-bottom: 5px;
  color: var(--biel-search-result-title-color);
  margin-top: 0;
}

.biel-search-result__description {
  color: var(--biel-search-result-description-color);
  margin: 0;
  word-break: break-word;
}

.biel-search-result__mark {
  color: var(--biel-search-result-mark-color);
  background-color: transparent;
  text-decoration: underline;
}

.biel-search-result {
  text-decoration: none;
}